import React from 'react';
import PropTypes from 'prop-types';

const LoaderLogo = ({
  size,
  className = '',
  style = {}
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 -8 90 88",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    className: className,
    style: style
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    className: "rhombus1",
    d: "M19.8793732,0.740879958 L38.4705682,38.8289303 C38.772455,39.4075466 38.772455,40.0867919 38.4705682,40.6654083 L19.9548449,78.7283013 C19.4768575,79.6842762 18.1183669,79.659119 17.6655367,78.7031441 L0.256731712,40.74088 C-0.0451550807,40.1119491 -0.0451550807,39.3823894 0.256731712,38.7283013 L17.7410084,0.76603719 C18.1686814,-0.139623187 19.4517003,-0.139623187 19.8793732,0.740879958 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rhombus2",
    d: "M41.1623921,0.740879958 L59.7535871,38.8289303 C60.0554739,39.4075466 60.0554739,40.0867919 59.7535871,40.6654083 L41.2378638,78.7283013 C40.7598764,79.6842762 39.4013858,79.659119 38.9485556,78.7031441 L31.3259141,62.0742133 L41.5649078,40.5899366 C41.8667946,40.0113202 41.8667946,39.2817605 41.5649078,38.5773579 L31.3007569,17.5207542 L39.0240273,0.740879958 C39.4517003,-0.139623187 40.7347191,-0.139623187 41.1623921,0.740879958 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "rhombus3",
    d: "M60.9108198,0.740879958 L79.7535871,38.8289303 C80.0554739,39.4075466 80.0554739,40.0867919 79.7535871,40.6654083 L61.2378638,78.7283013 C60.7598764,79.6842762 59.4013858,79.659119 58.9485556,78.7031441 L51.9045305,64.0113202 L63.0491845,40.5899366 C63.3510713,40.0113202 63.3510713,39.2817605 63.0491845,38.5773579 L51.7535871,15.3069177 L58.7976122,0.76603719 C59.2001279,-0.139623187 60.4579896,-0.139623187 60.9108198,0.740879958 Z"
  }))));
};

LoaderLogo.defaultProps = {
  size: 80
};
LoaderLogo.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
};
export default LoaderLogo;